var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',[_c('a',{attrs:{"href":"#","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.getVirtualSensor('3049fddd-c0a9-491a-9d71-8e92f03b5112')}}},[_vm._v(" Download the last virtual sensor data ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }